import { LoginProps } from "./login.types";
import { LoginView } from "./login-view";
import { useLogin } from "./use-login";

export const Login: React.FC<LoginProps> = ({ goToSignup, page }) => {
  const logic = useLogin({ page });

  return <LoginView {...logic} goToSignup={goToSignup} />;
};
